module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/authentication/forget-password/forget-password.component.scss
// module id = ./src/app/authentication/forget-password/forget-password.component.scss
// module chunks = main